import React from "react";
import { useState, useEffect } from "react";
import "../../index.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const WarningComponent = ({ path, setShowWarningComponent }) => {
  const navigate = useNavigate();
  const totalNoOptions = useSelector((state) => state.counter1.totalNoOptions);
  const warningData = useSelector((state) => state.counter1.comparisonData);
  const [showModal, setShowModal] = useState(false);
  const [exceedingItems, setExceedingItems] = useState([]);
  const [navigationPath, setNavigationPath] = useState("");

  // const [navigationName, setNavigationName] = useState(null);

  // useEffect(() => {
  //     const currentPath = window.location.hash.replace("#", "");
  //     if (!navigationName) {
  //         setNavigationName(currentPath);
  //     }
  // }, []);

  useEffect(() => {
    if (path && setShowWarningComponent) {
      if (totalNoOptions === undefined) {
        navigate(path);
        return;
      }

      const currentPath = window.location.hash.replace("#", "");
      if (path !== currentPath) {
        // Prevent showing the warning multiple times. Only display the warning when navigating to a different category.
        const itemsToWarn = Object.entries(warningData).filter(
          ([key, value]) => {
            if (value.navigationName === currentPath) {
              //Filtering the data from the object so that we show warning for Current/Active category only
              if (value.name === "poe") {
                return value.quantity < value.warning;
              } else {
                return value.quantity !== value.warning;
              }
            }
          }
        );

        // setNavigationName(path);

        if (itemsToWarn.length > 0) {
          setExceedingItems(itemsToWarn);
          setShowModal(true);
          setNavigationPath(path); //Sets where to navigate
        } else {
          navigate(path);
        }
      }
    }
  }, [path]);

  return (
    <div>
      <Modal show={showModal} backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title>Warning:</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <ul>
            {exceedingItems.map(([key, value]) => (
                <li key={key}>
                {value.name === "nvr"
                  ? // ? `Licenses in option ${key} are not equal to Total Cameras Selected in option ${key}.`
                    `Option ${key}: Licenses ≠ Cameras`
                  : value.name === "cameras"
                  ? // ? `There are not the same number of Cameras in option ${key} for Total Cameras Selected.`
                    `Option ${key}: Camera ≠ Required Cameras`
                  : value.name === "poe"
                  ? // ? `There are not enough PoE Ports for cameras in option ${key}.`
                    `Option ${key}: Not Enough PoE Ports for Cameras Selected`
                  : value.name === "hardware"
                  ? `Option ${key}: Hardware ≠ Drops`
                  : value.name === "cables"
                  ? // ? `There are less cameras and drops than cables in option ${key}.`
                    `Option ${key}: Cables ≠ Drops`
                  : value.name === "special"
                  ? `Option ${key}: Special Count is less than Drops`
                  : // : `Labor Count is less than Drops in option ${key}.`}
                    `Option ${key}: Labor ≠ Drops`}
              </li>
            ))}
          </ul>
          {/* Are you sure you want to continue? */}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              const currentPath = window.location.hash.replace("#", "");
              setExceedingItems([]); 
              // setNavigationName(currentPath);
              setShowModal(false);
              setNavigationPath("");
              setShowWarningComponent(false);
            }}
          >
            Go back
          </Button>
          <Button
            variant="dark"
            onClick={() => {
              setShowModal(false);
              if (navigationPath) {
                navigate(navigationPath);
              }
              setShowWarningComponent(false);
            }}
          >
            Continue Anyway
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default WarningComponent;
